export default (value: unknown): number | null => {
  if (typeof value == 'number') return value;
  return null;
};
